<template>

    <kt-modal
        :visible="recordVisible"
        :title="recordTitle"
        @dismiss="onDismiss()"
    >
        <template #body>
            <note-form v-model="record"></note-form>
        </template>
    
        <template #footer>
            <div class="row w-100">
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="onDismiss()" 
                        class="btn btn-sm btn-outline-secondary form-control"
                    >Close</button>
                </div>
                <div class="col-4" v-if="record.Id">
                    <button @click="deleteRecord()"
                        class="btn btn-sm btn-outline-danger form-control"
                    >Delete</button>
                </div>
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="saveRecord()"
                        class="btn btn-sm btn-outline-primary form-control"
                    >Save</button>
                </div>
            </div>
        </template>
    </kt-modal>
        
    
    </template>
    
    
    <script setup>
    
    import { ref, onMounted, onUpdated } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import { useAppStore } from "@/stores/AppStore";
    import Api from "@/services/Api";
    import Helper from "@/services/Helper";
    import Alert from "@/services/Alert";
    import noteForm from "@/components/Notes/NoteForm.vue";
    import KtModal from "@/components/UI/KtModal.vue";
    
    const route = useRoute();
    const router = useRouter();
    const appStore = useAppStore();
    const recordTitle = ref("Note Entry");
    const recordVisible = ref(true);
    
    const props = defineProps({
        taskId: {
            type: Number,
            default: 0
        },
        requestId: {
            type: Number,
            default: 0
        },
        clientId: {
            type: Number,
            default: 0
        },
        embedded: {
            type: Boolean,
            default: false
        }
    });
    
    const emit = defineEmits(["cancel", "saved"]);
    
    const newRecord = () =>
    {
        return {
            UserId: "",
            ClientId: "",
            RequestId: "",
            DateTaken: "",
            Note: ""
        };
    };
    
    const record = ref(newRecord());
    
    const saveRecord = async () =>
    {
        let pay = record.value;

        if (pay.DateTaken) {
            pay.DateTaken = new Date(pay.DateTaken);
        }

        await Api.saveNote(pay);

        if (props.embedded) {
            emit("saved");
        } else {
            router.push({
                path: "/note/list"
            });
        }
    };
    
    const deleteRecord = async () =>
    {
        Alert.notify({
            text: "Deletion has been disabled"
        });
    };
    
    
    const onDismiss = () =>
    {
        if (props.embedded) {
            emit("cancel");
        } else {
            router.push({
                path: "/note/list"
            });
        }
    };
    
    onMounted(async () =>
    {
        if (props.embedded && props.requestId) {
            // In embedded mode, create a new note for the request
            let newRec = newRecord();
            newRec.TaskId = props.taskId;
            newRec.RequestId = props.requestId;
            newRec.ClientId = props.clientId;
            newRec.UserId = appStore.account?.user?.UserId;
            record.value = newRec;
        } else {
            // Original routing-based logic
            switch (route.params.id)
            {
                case "new":
                    record.value = newRecord();
                    break;
        
                default:
        
                    let rec = await Api.loadNote(route.params.id);

                    /* fix any elements
                    if (rec.DateTaken) {
                        rec.DateTaken = new Date(rec.DateTaken + "Z");
                        rec.DateTaken = Helper.dateToInput(rec.DateTaken);
                    }
                        */

                    record.value = rec;
                    break;
            }
        }
    });
    
    </script>